import { useMatches, type StaticDataRouteOption } from "@tanstack/react-router";

export function useRouteOptions() {
  return useMatches({
    select: (matches) =>
      matches.reduce<StaticDataRouteOption>(
        (options, match) => {
          options.title = match.staticData.title || options.title;
          if (match.staticData.viewPadding !== undefined) {
            options.viewPadding = match.staticData.viewPadding;
          }
          return options;
        },
        { title: "", viewPadding: "1rem" },
      ),
    structuralSharing: true,
  });
}
